// ReviewSummary.jsx
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import starIcon from '../assets/icon/star.svg';
import { getReviewSurahsSummary } from '../actions/appAction';
import back from '../assets/icon/back.svg';
import './ReviewSummary.css';

const ReviewSummary = () => {
  const { reviewSummary, error, loading } = useSelector((state) => state.app);
  // console('err', error);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reviewData, setReviewData] = useState([]);

  useEffect(() => {
    dispatch(getReviewSurahsSummary());
  }, [dispatch]);

  useEffect(() => {
    if (reviewSummary && reviewSummary.surahs) {
      const filtered = reviewSummary.surahs.filter(
        (surah) => surah.total_chunks > 0
      );
      setReviewData(filtered);
    }
  }, [reviewSummary]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!reviewSummary || !reviewSummary.surahs) {
    return <div className="no-data">لا يوجد بيانات للمراجعة</div>;
  }

  // If after filtering there's nothing to show
  if (reviewData.length === 0) {
    return (
      <div className="review-summary-wrapper">
        <div className="back-icon-container">
          <img
            className="back-icon"
            src={back}
            alt="back"
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="no-data">
          لا يوجد سور قيد الحفظ او المراجعة
        </div>
      </div>
    );
  }

  return (
    <div className="review-summary-wrapper">
      <div className="back-icon-container">
        <img
          className="back-icon"
          src={back}
          alt="back"
          onClick={() => navigate(-1)}
        />
      </div>

      {reviewData.map((surah) => {
        const total = surah.total_chunks || 0;
        const underReview = total
          ? (surah.under_review_count / total) * 100
          : 0;
        const complete = total
          ? (surah.complete_count / total) * 100
          : 0;
        const reviewPercentage = Math.round(underReview);
        const completePercentage = Math.round(complete);
        const displayedPercentage = Math.max(
          reviewPercentage,
          completePercentage
        );

        return (
          <div key={surah.surah_number} className="surah-row">
            <div className="surah-info">
              <div className="star-icon-wrapper">
                <img src={starIcon} alt="star" className="star-icon" />
                <span className="star-text">{surah.total_ayahs}</span>
              </div>
              <span className="surah-named">سورة {surah.name_ar}</span>
            </div>

            <div className="progress-row">
              <div className="progress-bar-background">
                <div
                  className="progress-bar-complete"
                  style={{ width: `${completePercentage}%` }}
                />
                <div
                  className="progress-bar-review"
                  style={{ width: `${reviewPercentage}%` }}
                />
              </div>
              <span className="progress-label">
                {displayedPercentage}%
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReviewSummary;
